<template>
    <div>
        <div v-if="pending">
            <BaseSpinner />
        </div>
        <template v-else-if="!entry" /> <!-- empty case for when there is no entry, nuxt will show an error -->
        <article v-else>
            <HeroBasic
                :title="entry?.title"
                :image="entry?.image?.[0]"
                :video="entry?.video"
                :description="entry?.textarea"
                class="hero-basic--display"
            >
                <template
                    v-if="entry?.startDate"
                    #date
                >
                    <BaseDate
                        v-if="entry?.startDate"
                        :start-date="entry?.startDate"
                        :end-date="entry?.endDate"
                    />
                </template>
            </HeroBasic>

            <FlexibleSections
                v-if="entry.flexibleSections"
                :sections="entry.flexibleSections"
            />
        </article>
    </div>
</template>

<script setup>
import { formatISO } from 'date-fns';
import getPage from '~/graphql/queries/getPage.graphql';

defineI18nRoute({
    paths: {
        en: '/agenda/[slug]',
    }
});

const route = useRoute();
const { variables: defaultVariables }  = useCraftGraphql();

const now = formatISO(Date.now(), { representation: 'date' });

const variables = computed(() => {
    return {
        ...defaultVariables,
        uri: null,
        section: 'events',
        slug: route.params.slug,
        now: ['or', `>= ${now}`, null]
    };
});

const response = await useAsyncQuery({
    query: getPage,
    variables
});

// using response.pending in template is not reactive???
const pending = computed(() => response?.pending.value);

const { craftEntry: entry } = useCraftPageEther(response);

const mainStore = useMainStore();
watchEffect(() => {
    mainStore.toggleNewsletterSubscribe(entry?.value?.showNewsletterSubscribe ?? false);
});
</script>
